import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ResponseSettings, UserInfo } from '../type/auth.interface';
import { Observable } from 'rxjs';
import {
  AlarmDict
} from '../type/employee.interface';
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient,
              private router: Router) {
  }
  login(userInfo: FormData): Observable<UserInfo> {
    return this.http.post<UserInfo>( environment.apiUrl + 'auth', userInfo);
  }

  getInfo(): Observable<UserInfo> {
    return this.http.get<UserInfo>(environment.apiUrl + 'convicted/me');
  }

  getBalance() {
    return this.http.post<{Balance: string}>(environment.apiUrl + 'convicted/card_balance', {})
  }

}
